'use client';

import React from 'react';
import { SignupForm } from '@/components/SignupForm';

export default function Page() {
  return (
    <div className="flex flex-col lg:flex-row w-full min-h-screen">
      {/* Left panel — brand */}
      <div className="brand-panel relative flex flex-col items-center justify-center lg:w-[48%] min-h-[320px] lg:min-h-screen overflow-hidden px-10 py-20 lg:py-0">
        {/* Warm gradient overlay for depth */}
        <div
          className="absolute inset-0 z-0"
          style={{
            background: 'linear-gradient(145deg, #c4af87 0%, #BAA57B 40%, #a89468 100%)',
          }}
        />

        {/* Large S icon watermark */}
        <img
          src="/light.svg"
          alt=""
          aria-hidden="true"
          className="absolute z-[1] opacity-[0.08] w-[500px] lg:w-[600px] -left-20 top-1/2 -translate-y-1/2 select-none pointer-events-none"
        />

        {/* Subtle organic shapes */}
        <div
          className="absolute top-[10%] right-[5%] w-[200px] h-[200px] rounded-full opacity-[0.12] blur-[60px] z-[1]"
          style={{ background: '#CAFF75' }}
        />
        <div
          className="absolute bottom-[15%] left-[10%] w-[160px] h-[160px] rounded-full opacity-[0.08] blur-[50px] z-[1]"
          style={{ background: '#EFEDD9' }}
        />

        {/* Logo wordmark */}
        <div className="relative z-10 flex flex-col items-center gap-6">
          <img src="/horizontal-dark.svg" alt="Steno.ai" className="w-[200px] lg:w-[240px]" />
        </div>
      </div>

      {/* Right panel — form */}
      <div className="relative flex items-center justify-center lg:w-[52%] bg-sand px-6 sm:px-10 py-14 lg:py-0">
        {/* Subtle top-left corner accent */}
        <div
          className="hidden lg:block absolute top-0 left-0 w-[300px] h-[300px] opacity-[0.04] z-0"
          style={{
            background: 'radial-gradient(circle at top left, #BAA57B 0%, transparent 70%)',
          }}
        />

        <div className="relative z-10 w-full max-w-[420px]">
          <SignupForm id="steno" />
        </div>
      </div>
    </div>
  );
}
